import * as companyManagementService from "../../../services/company";
import * as settings from "../../../services/settings";

import { Button, Col, Form, Image, Input, Modal, Row, Select, Upload, message, notification } from "antd";
import { useCallback, useEffect, useState } from "react";
import { ImagePreview, UploadButton, createHandlePreview, createHandleUpload } from "../../../utils/uploadUtils.jsx";

import { Spin } from "antd";
import { useAccessToken } from "../../../contexts/AccessTokenContext";
import { resolveImageUrl } from "../../../utils/imageUrl";

const initPage = { limit: 0, page: 1 };
let checkLoop = 0;

export const ModelCreateSales = ({
  t,
  type,
  isModalOpen,
  // handleOk,
  handleCancel,
  editCompanySalesData,
  setIsModalOpen,
  fetchCompanySales,
  isEditSale,
  companyCode,
  isDisableSelectCompany,
  optionCompany,
  optionDefaultCompany,
}) => {
  const { accessToken } = useAccessToken();
  const [formSale] = Form.useForm();
  const [imageSales, setImageSales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectCompany, setSelectCompany] = useState([]);
  const [search, setSearch] = useState(initPage);
  // upload image
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const [messageApi, contextMessage] = message.useMessage();
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (type, message, description) => {
      api[type]({ message, description });
    },
    [api]
  );

  const handleUpload = createHandleUpload(messageApi);
  const handlePreviewImage = createHandlePreview(setPreviewImage, setPreviewOpen);

  const handleChangeImage = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const uploadButton = <UploadButton />;

  const fetchSetDataSaleImage = useCallback(async (editCompanySalesData) => {
    formSale.setFieldValue("sale_code", editCompanySalesData.sale_code);
    formSale.setFieldValue("sale_name", editCompanySalesData.sale_name);
    formSale.setFieldValue(
      "company_id",
      editCompanySalesData.company_id ?? editCompanySalesData.app_company?.id
    );
    formSale.setFieldValue("email", editCompanySalesData.email);
    formSale.setFieldValue("telephone", editCompanySalesData.telephone);

    if (editCompanySalesData.app_saleimage !== undefined && editCompanySalesData.app_saleimage.length > 0) {
      checkLoop++;
      if (checkLoop === 1) {
        let listImages = [];
        await editCompanySalesData.app_saleimage.map((value) => {
          let subUidImage = value.image.substring(31, 67);
          let newImages = {
            uid: subUidImage,
            name: `image_${value.id}.png`,
            status: "done",
            url: resolveImageUrl(value.image),
            id: value.id,
          };
          listImages.push(newImages);
        });
        await setFileList(listImages);
      }
    }
  });
  if (isEditSale) {
    fetchSetDataSaleImage(editCompanySalesData);
  }

  const onSubmitRoutes = async () => {
    const values = await formSale.getFieldsValue();
    const { sale_code, sale_name, email, telephone, company_id } = values || {};
    const fromData = new FormData();

    if (
      (optionDefaultCompany === "all" || optionDefaultCompany === "All") &&
      (company_id === "all" || company_id === "All")
    ) {
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`Please, select company`}</>);
      return;
    }
    const companyId = companyCode ? companyCode.id : company_id;
    fromData.append("company_id", companyId);
    fromData.append("sale_code", sale_code || "");
    fromData.append("sale_name", sale_name || "");
    fromData.append("note", "");
    fromData.append("email", email || "");
    fromData.append("telephone", telephone || "");
    const old_images = [];
    if (fileList.length > 0) {
      fileList.map((file) => {
        if (file.id) {
          old_images.push(file.id);
        } else {
          fromData.append("file", file.originFileObj);
        }
      });
      fromData.append("old_images", JSON.stringify(old_images));
    }
    setLoading(true);
    try {
      if (isEditSale) {
        if (typeof company_id === "string") {
          fromData.append("company_id", editCompanySalesData.company_id);
        }
        fromData.append("id", editCompanySalesData.id);
        const response = await companyManagementService.updateCompanySale(accessToken, fromData);
        openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Update sales success"}</>);
      } else {
        const response = await companyManagementService.createCompanySale(accessToken, fromData);
        openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Create sales success"}</>);
      }
      setIsModalOpen(false);
      fetchCompanySales();
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[ModelCreateSales] onSubmitSales: ", err);
      setLoading(false);
    }
  };

  const fetchCompany = useCallback(
    async (param) => {
      formSale.setFieldValue();
      setLoading(true);
      let resCompany = [];
      try {
        const data = await companyManagementService.getCompany(accessToken, param);
        if (data) {
          data.queryCompany.map((value) => {
            resCompany.push({
              value: value.id,
              label: value.company_name,
            });
          });
        }
        setSearch({ ...param });
        setSelectCompany(resCompany);
      } catch (err) {
        console.error("[ModelCreateSales] fetchCompany: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
      setLoading(false);
    },
    [accessToken]
  );

  useEffect(() => {
    const initFetchCompany = async () => {
      try {
        setLoading(true);
        if (accessToken) {
          fetchCompany(search);
        }
        if (optionDefaultCompany != null && !Array.isArray(optionDefaultCompany)) {
          formSale.setFieldsValue({ company_id: optionDefaultCompany });
        }
        setLoading(false);
      } catch (err) {
        console.error("[ModelCreateSales] initFetchCompany: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
    };
    initFetchCompany();
  }, [accessToken, fetchCompany, optionDefaultCompany]);

  useEffect(() => {
    if (!isModalOpen || !companyCode?.id) return;
    formSale.setFieldsValue({ company_id: companyCode.id });
  }, [isModalOpen, companyCode, formSale]);

  const companyOptions = optionCompany?.length > 0 ? optionCompany : selectCompany;
  const companyDisplayLabel = companyCode
    ? [companyCode.company_name, companyCode.company_code ? `(${companyCode.company_code})` : ""]
        .filter(Boolean)
        .join(" ")
    : "";

  return (
    <>
      {contextMessage}
      {contextHolder}
      <Spin spinning={loading}>
        <Modal
          title={t("Company_Create.Create_Sales.Text_Add_Edit_Sales")}
          open={isModalOpen}
          className="rounded-lg border-2"
          closable={true}
          centered={true}
          forceRender={true}
          width={1060}
          // onOk={handleOk}
          onCancel={handleCancel}
          footer={() => (
            <>
              <Button type="primary" onClick={onSubmitRoutes}>
                {t("BTN_Save", { ns: "buttons" })}
              </Button>
              <Button onClick={handleCancel}>{t("BTN_Cancel", { ns: "buttons" })}</Button>
            </>
          )}
        >
          <Form form={formSale} labelAlign="left" labelCol={{ flex: "120px" }}>
            <Row className="mt-6" gutter={10}>
              <Col flex={4}>
                <Form.Item
                  label={t("Company_Create.Create_Sales.Input_Sales_Code") + ":"}
                  name="sale_code"
                  key="sale_code"
                  style={{ marginBottom: "1rem" }}
                >
                  <Input allowClear={true} size="default" maxLength={3} />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Sales.Input_Sales_Name") + ":"}
                  name="sale_name"
                  key="sale_name"
                  style={{ marginBottom: "1rem" }}
                >
                  <Input allowClear={true} size="default" />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Sales.Input_Sales_Company") + ":"}
                  name="company_id"
                  key="company_id"
                  style={{ marginBottom: "1rem" }}
                >
                  {companyCode ? (
                    <Input disabled size="default" value={companyDisplayLabel} />
                  ) : (
                    <Select
                      style={{ width: "100%" }}
                      disabled={isDisableSelectCompany}
                      showSearch
                      optionFilterProp="label"
                      options={companyOptions}
                      allowClear={!isDisableSelectCompany}
                    />
                  )}
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Sales.Table_Email") + ":"}
                  name="email"
                  key="email"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                >
                  <Input allowClear={true} size="default" />
                </Form.Item>
                <Form.Item
                  label={t("Company_Create.Create_Sales.Table_Tel") + ":"}
                  name="telephone"
                  key="telephone"
                  style={{ marginBottom: "1rem" }}
                  normalize={(value) => value.trim()}
                >
                  <Input allowClear={true} size="default" maxLength={10} />
                </Form.Item>
              </Col>
              <Col flex={1} style={{ width: "500px" }}>
                <Col span={24}>
                  <Upload
                    customRequest={handleUpload}
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreviewImage}
                    onChange={handleChangeImage}
                    maxCount={1}
                  >
                    {fileList.length >= 1 ? null : uploadButton}
                  </Upload>
                  <ImagePreview
                    previewImage={previewImage}
                    previewOpen={previewOpen}
                    setPreviewOpen={setPreviewOpen}
                    setPreviewImage={setPreviewImage}
                    Image={Image}
                  />
                </Col>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Spin>
    </>
  );
};
